import React, {useState} from 'react';
import { Link } from "react-router-dom";
import {Navigate} from "react-router-dom";
import _ from "lodash";

import Icon from "../components/Icon";
import {Button} from "../components/Button";
import pictureLogo from '../../images/logoc.png';
import createLink from "../../libs/createLink";
import {CheckboxInputField} from "../components/FormField";
import {Helmet} from "react-helmet";
import {config} from "../../config";
import {canonical} from "../../libs/helper";
import illustration from "../../images/pages/signup/6.jpg";
import AskSex from "../components/SignUpInformation/components/AskSex";
import PasswordStrength from "../components/PasswordStrength";
import passwordStrength from "../../libs/passwordStrength";
import classNames from "classnames";
import {useMutation} from "@tanstack/react-query";
import {signupUser} from "../../api/public-voissa/users";
import useCurrentUser from "../../queries/currentUser";



const initDataUser = {
    username: "",
    email: "",
    password: "",
    gender : 0,
    cgu: false,
    showPassword : false,
    passwordStrengthError : false,
    error : false
}


const Signup = () => {
    const [user, setUser] = useState(initDataUser);
//todo : ( j'ai mi un timeaout a 50sec car debounce.io met parfois plus de 40 secondes a repondre a retire quand on aura régle ca )
    const {isLoading, error, isError, isSuccess, mutate } = useMutation(data => signupUser(data, {timeout : 1000 * 50}));
/*
    const {isSuccess : isSuccessUser} = useQuery(
        [USER_CURRENT_KEY],
        ()=> fetchUserCurrent(),
        {
            staleTime : (1000 * 60 * 2),
            enabled : isSuccess
        }
    );*/
    const {isSuccess : isSuccessUser} = useCurrentUser({enabled : isSuccess});

    if(isSuccessUser){
        return <Navigate to={createLink("firstConnexion")}/>
    }


    function _updateFieldUser(key, value){
        setUser({...user, [key] : value});
    }

    function _handlePasswordValidation(password){
        let passwordStrengthError = !!password ? !passwordStrength(password).isValid : false;
        setUser({...user, password, passwordStrengthError});
    }

    function _onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        let error = !(user.cgu && user.gender !== 0 && !user.passwordStrengthError);

        if(!error){
            mutate({
                username: user.username,
                email: user.email,
                password: user.password,
                //newsletter: this.state.newsletter,
                gender : user.gender,
                source : localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "voissa"
            })
        }
        else{
            setUser({...user, error});
        }
    }

    return (
        <div id="signup">
            <Helmet>
                <title>{config.preTitle}Inscription{config.postTitle}</title>
                <link rel="canonical" href={canonical(createLink("signup"), "", "signup")}/>
            </Helmet>
            <div className="black-layer"/>
            <div className="container">
                <div className="card">
                    <div className="main-wrapper">
                        <img className="voissa-logo" src={pictureLogo} alt={"Voissa logo"}/>
                        {/*<Title heading={"heading-1"} display={"display-1"}>Inscription Voissa</Title>*/}
                        <p className="sub-title">Le plus bel espace de liberté.</p>
                        <form onSubmit={(event) => _onSubmit(event)}>
                            <div className="input-group">
                                <input className="bottom-bar-style" value={user.username}
                                       onChange={(event) => _updateFieldUser("username", event.target.value)}
                                       required={true}
                                       type="text"
                                       placeholder="Choisissez un pseudonyme *"
                                />
                                {isError && _.get(error,'errors.login') ? <span className="input-error">{error.errors.login}</span> : null}
                            </div>
                            <div className="input-group">
                                <input className="bottom-bar-style" value={user.email}
                                       onChange={(event) => _updateFieldUser("email", event.target.value)}
                                       required={true} type="email" placeholder="Votre Email *"/>
                                {isError && _.get(error,'errors.email') ? <span className="input-error">{error.errors.email}</span> : null}
                            </div>
                            <div className="input-group password">
                                <input value={user.password}
                                       className={classNames(["bottom-bar-style",{error:user.passwordStrengthError}])}
                                       onChange={(event) => _handlePasswordValidation(event.target.value)}
                                       required={true} type={user.showPassword ? "text" : "password"}
                                       placeholder="Votre mot de passe *"
                                       autoComplete="new-password"/>
                                <span className={"show-password"}
                                      onClick={() => _updateFieldUser("showPassword", !user.showPassword)}><Icon
                                    type={user.showPassword ? "eye-cut" : "eye"}/></span>
                            </div>
                            {!!user.password && <PasswordStrength password={user.password}/>}

                            <AskSex gender={user.gender} isError={(user.error && user.gender === 0)} handleBlockSelection={(value, key)=>_updateFieldUser(key, value)}/>


                            <CheckboxInputField checked={user.cgu}
                                required={true}
                                error={user.error && !user.cgu}
                                onChange={() => _updateFieldUser("cgu", !user.cgu)}
                                label={<span>J'ai lu et j'accepte <Link to="/cgus">les termes d'utilisation</Link>*</span>}
                                id={"terms"}
                                htmlFor={"terms"}/>

                            <span className="signup-infos">*Champs obligatoires</span>

                            {isError && error.statusCode === 409 && (
                                <span className="warning">Email ou Login déjà utilisé</span>
                            )}
                            {isError && error.statusCode === 400 &&(
                                <span className="warning">{error.message}</span>
                            )}
                            {isError && error.statusCode === "ECONNABORTED" &&(
                                <span className="warning">Nous avons rencontré un probleme, merci de renouveler d'ici quelques minutes</span>
                            )}
                            <Button
                                btnType={"submit"}
                                loading={isLoading}
                                size={"big"}
                                btnStyle={"primary-reverse"}
                                content={"Commencez l'aventure Voissa"}/>

                        </form>
                        <div className={"row bottom-infos"}>
                            <Link className={"go-to-signin"} to={createLink("signin")}>J'ai déjà un compte</Link>
                        </div>
                    </div>
                    <div className={"voissa-advantage"}>
                        <div className={"voissa-touch-img"}>
                            <img
                                src={illustration}
                                alt={"voissa touch"}/>
                        </div>
                        <div className={"free"}>
                            <div className={"free-wrapper"}>
                                <div className={"text-icon"}><Icon type={"free"}/> C'EST GRATUIT</div>
                                <div className={"text-icon"}><Icon type={"incognito"}/> ANONYME</div>
                                <div className={"text-icon"}><Icon type={"secure"}/> 100% SECURISÉ</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Signup;